






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { BasketQuoteViewObject } from '@/types/apiServerContract';
import BasketLineItem from './BasketLineItem.vue';
import loggingService from '@/core/logging.service';
import basketService from '@/project/basket/basket.service';

@Component({
    components: { BasketLineItem }
})
export default class BasketQuote extends Vue {
    @Prop({
        required: true,
        type: Object
    }) quote!: BasketQuoteViewObject;

    @Prop({
        required: true,
        type: Function
    }) addLineItem!: () => void;

    priceNotAvailable() {
        this.$emit('priceNotAvailable');
    }

    async removeQuote() {
        try {
            await basketService.removeQuote(this.quote.quoteId);
        } catch (e) {
            loggingService.error(e);
        }
    }
}
